import React from "react";
import Button from "./Button";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("[ErrorBoundary]", error, errorInfo);
        if (this.props.onError) this.props.onError(error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    handleReload = () => {
        window.location.reload();
    };

    handleDashboard = () => {
        window.location.href = "/Dashboard";
    };

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) return this.props.fallback;

            const isDev = process.env.NODE_ENV === "development";

            return (
                <div className="ui-error-boundary">
                    <div className="ui-error-boundary__card">
                        <svg className="ui-error-boundary__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 8v4M12 16h.01" />
                        </svg>
                        <h1 className="ui-error-boundary__title">Something went wrong</h1>
                        <p className="ui-error-boundary__message">
                            An unexpected error occurred. You can try reloading the page or navigating back to the dashboard.
                        </p>
                        {isDev && this.state.error && (
                            <pre className="ui-error-boundary__detail">
                                {this.state.error.toString()}
                            </pre>
                        )}
                        <div className="ui-error-boundary__actions">
                            <Button variant="secondary" onClick={this.handleDashboard}>
                                Go to Dashboard
                            </Button>
                            <Button variant="primary" onClick={this.handleReload}>
                                Reload Page
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
